import { useState, useEffect } from 'react';

const useImage = (src: string | null, crossOrigin: string = 'anonymous') => {
  const [image, setImage] = useState<HTMLImageElement | null>(null);
  const [status, setStatus] = useState<'loading' | 'loaded' | 'error'>(
    'loading'
  );

  useEffect(() => {
    if (!src) {
      setImage(null);
      setStatus('loaded');
      return;
    }

    const img = new window.Image();

    // Set crossOrigin before setting src to ensure CORS headers are requested
    img.crossOrigin = crossOrigin;

    img.onload = () => {
      setImage(img);
      setStatus('loaded');
    };

    img.onerror = () => {
      setImage(null);
      setStatus('error');
    };

    img.src = src;

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [src, crossOrigin]);

  return [image, status] as const;
};

export default useImage;
